import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import type {
  GenerateVouchersRequest,
  ImportVouchersRequest,
  SetCommissionTierRatesRequest,
  SetVoucherCommissionRequest,
  SetVoucherStatusRequest,
  VoucherListParams,
} from '@/marketing/models/voucher';
import { voucherAPIClient } from '../voucherAPIClient';
import { VOUCHER_KEYS } from './keys';

const LIST_STALE_TIME_MS = 30 * 1000;
const PERFORMANCE_STALE_TIME_MS = 60 * 1000;

export const VOUCHER_QUERIES = {
  list: (params: VoucherListParams) =>
    queryOptions({
      queryKey: VOUCHER_KEYS.list(params),
      queryFn: () => voucherAPIClient.listVouchers(params),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE_TIME_MS,
    }),
  performance: (code: string) =>
    queryOptions({
      queryKey: VOUCHER_KEYS.performance(code),
      queryFn: () => voucherAPIClient.getPerformance(code),
      staleTime: PERFORMANCE_STALE_TIME_MS,
      enabled: code !== '',
    }),
  tierRates: () =>
    queryOptions({
      queryKey: VOUCHER_KEYS.tierRates(),
      queryFn: () => voucherAPIClient.getCommissionTierRates(),
      staleTime: LIST_STALE_TIME_MS,
    }),
};

export const VOUCHER_MUTATIONS = {
  generate: () => ({
    mutationFn: (request: GenerateVouchersRequest) => voucherAPIClient.generateVouchers(request),
  }),
  import: () => ({
    mutationFn: (request: ImportVouchersRequest) => voucherAPIClient.importVouchers(request),
  }),
  setStatus: () => ({
    mutationFn: (request: SetVoucherStatusRequest) => voucherAPIClient.setVoucherStatus(request),
  }),
  setCommission: () => ({
    mutationFn: (request: SetVoucherCommissionRequest) => voucherAPIClient.setVoucherCommission(request),
  }),
  setTierRates: () => ({
    mutationFn: (request: SetCommissionTierRatesRequest) => voucherAPIClient.setCommissionTierRates(request),
  }),
};
